<template>
	<div class="design">
		<section class="design__header">
			<el-link @click.stop="handleSave('back')" icon="el-icon-back" type="text" :underline="false">返回</el-link>
			<el-divider direction="vertical"></el-divider>
			<span class="title">设计问卷</span>
			<div class="group">
				<el-button @click.stop="handlePreview" size="mini" round plain>预览</el-button>
				<el-button @click.stop="handleSave" type="primary" size="mini" round plain>保存</el-button>
				<el-button @click.stop="handleSave('close')" type="primary" size="mini" round>保存并关闭</el-button>
			</div>
		</section>
		<section class="design__container">
			<el-container 
				class="v-form-box">
				<el-aside class="v-form-box__left" width="100px">
					<ElementCate />
				</el-aside>

				<el-main class="v-form-box__middle">
					<ButtonView @onChangeFormData="handleFormData" :formData="formData" />
				</el-main>

				<el-aside class="v-form-box__right" width="350px">
					<ConfigOption @onChangeFormData="handleFormData" :formData="formData" />
				</el-aside>
			</el-container>
		</section>
		<el-dialog
			:title='formData.formInfo.paperName'
			:visible.sync="dialog_visible_preview"
			:modal-append-to-body="false"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:fullscreen="true"
			:z-index="999999" center>
			<FormPreview v-if="dialog_visible_preview" :formData="formData" />
		</el-dialog>
	</div>
</template>

<script>
import ElementCate from "./components/ElementCate";
import ButtonView from "./components/ButtonView";
import ConfigOption from "./components/ConfigOption";
import FormPreview from "./components/FormPreview";

export default {
	name: "VForm",
	props: ['originData'],
	components: {
		ElementCate,
		ButtonView,
		ConfigOption,
		FormPreview
	},
	data() {
		return {
			formData: {
				formInfo: {},
				formDesign: [],
				formSelect: {},
			},
			component_obj: {
				1: 'DwRadio',
				2: 'DwCheckbox',
				3: 'DwTextarea',
				4: 'DwJudge',
				6: 'DwSelect'
			},
			dialog_visible_preview: false
		}
	},
	created() {
		this.formData = Object.assign(this.formData, this.originData);
		for(const [index, item] of this.formData?.formDesign.entries()) {
			if(item.questionType == 2) {
				this.$set(item, 'defaultValue', item.defaultValue ? item.defaultValue.split(',') : '');
			}
			
			this.$set(item, 'serial', index + 1);
			this.$set(item, 'component', this.component_obj[item.questionType]);
		}
	},
	methods: {
		handleSave(close){
			for(const item of this.formData.formDesign) {
				if(item.defaultValue instanceof Array) {
					item.defaultValue = item.defaultValue.toString();
				}
				for(const _item of item.ruleList) {
					if(!this.isString(_item.ruleCode)) {
						_item.ruleCode = JSON.stringify(_item.ruleCode);
					}
				}
			}
			this.$emit('onChangeFormDataSave', this.formData, close);
		},
		handleFormData(data) {
			this.formData = Object.assign(this.formData, data);
			for(const [index, item] of this.formData?.formDesign.entries()) {
				this.$set(item, 'serial', index + 1);
				this.$set(item, 'component', this.component_obj[item.questionType]);
			}
			this.$emit('onChangeFormData', this.formData);
		},
		handlePreview() {
			this.dialog_visible_preview = true;
		},
		isString(str){
			if(Object.prototype.toString.call(str) === "[object String]"){
				return true;
			}else{
				return false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.design {
	width: 100%;
	height: 100%;
	background: #FBFBFC;
	overflow: hidden;
	padding: 5px 10px;

	&__header {
		width: 100%;
		height: 40px;
		line-height: 40px;
		padding: 0 5px;

		& .el-link {
			vertical-align: top;
			color: #303133;
		}

		& .el-divider {
			vertical-align: top;
			margin-top: 13px;
		}

		& > .title {
			font-size: 14px;
			font-weight: bold;
			color: #303133;
			vertical-align: top;
			letter-spacing: .5px;
		}

		& > .group {
			height: 100%;
			float: right;
			
			& .el-button {
				vertical-align: top;
				margin-top: 5px;
			}
		}
	}

	&__container {
		width: 100%;
		height: calc(100% - 40px);
		overflow: hidden;

		& .v-form-box{
			width: 100%;
			height: 100%;
			background: #FBFBFC;
			overflow: hidden;

			&__left {
				width: 244px;
				height: 100%;
				display: inline-block;
				vertical-align: top;
				border: solid 1px #E9E9E9;
				border-top-right-radius: 4px;
				overflow: hidden;
				padding: 0;
			}

			&__middle {
				height: 100%;
				display: inline-block;
				vertical-align: top;
				overflow: hidden;
				border: solid 1px #E9E9E9;
				border-top-right-radius: 4px;
				border-top-left-radius: 4px;
				overflow: hidden;
				margin: 0 8px;
				padding: 0;
			}

			&__right {
				display: inline-block;
				vertical-align: top;
				width: 310px;
				height: 100%;
				border: solid 1px #E9E9E9;
				border-top-left-radius: 4px;
				overflow: hidden;
				padding: 0;
			}
		}
	}
}

</style>
